/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import React, {useState} from 'react';
import { IPromoBannerViewProps } from './absolute-promo-banner';

import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';

const PromoBannerView: React.FC<IPromoBannerViewProps> = props => {
    const {
        promoBannerProps,
        contentProps,
        closeButton,
        bannerMessages,
        PromoBannerTextProps,
        PromoBannerLinksProps,
        CarouselProps,
        handleLinks,
        handleText
    } = props;

    const [modal, setModal] = useState(false);
    const toggle = () => setModal(!modal);

    const slides = bannerMessages && bannerMessages.map((message, index) => {
        return (
            <Node {...contentProps} key={index}>
                {message.text && <Node {...PromoBannerTextProps} text={message.text} onClick={handleText}/>}
                {message.links && message.links.length > 0 && <Node {...PromoBannerLinksProps} links={message.links} onClick={handleLinks} />}
                <Button color="warning" onClick={toggle}>Learn More</Button>
                <Modal isOpen={modal} toggle={toggle} >
                    <ModalHeader toggle={toggle}>Notice on Inventory</ModalHeader>
                    <ModalBody className="flex-md">
                        <div className="thirty"></div>
                        <div className="seventy">
                            <p>Due to high demand, and disruptions in supply chain, some items may be temporarily out of stock. As products become available, we will continue to add them to the website, so please check back often.</p>
                        </div>
                    </ModalBody>
                </Modal>

            </Node>
        );
    });

    return (
        <Module {...promoBannerProps}>
            <Node {...CarouselProps} items={slides} />
            {closeButton}
        </Module>
    );
};
export default PromoBannerView;
